export default __webpack_public_path__ + "static/media/assetSample2@2x.dffc8038.png";